module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    staticClass: "chapter-title"
  }, [_vm._v("50 PASSAGEWAYS TO RICHES")]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chap001#pass_1"
    }
  }, [_vm._v("1. Time Management")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chap001#pass_2"
    }
  }, [_vm._v("2. Creative Deal Structuring")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap002#pass_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Buying With OPM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap002#pass_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Mice and Elephants")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap002#pass_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Buying Foreclosures")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap002#pass_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Short Sales")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap002#pass_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Going Into Contract")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap002#pass_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. The Bank")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap003#pass_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. A Plan of Action")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/chap003#pass_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Finding Money")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/chap003#pass_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Retailing Houses")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/chap003#pass_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. Wholesaling Houses")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/chap003#pass_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. Options")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/chap003#pass_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. Lease Options")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/chap003#pass_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. FSBO's")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/chap004#pass_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. Cash Flow")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/chap005#pass_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. Buying and Holding")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/chap005#pass_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. Selecting Contractors")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/chap005#pass_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. Hiring Advisors")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/chap007#pass_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. Setting Up A Business")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/chap007#pass_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21. It's None of My Business")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/chap007#pass_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22. Commercial Real Estate")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/chap007#pass_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23. Property Management")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/chap007#pass_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24. Buying Notes and Liens")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/chap007#pass_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25. Taxes and Insurance")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/chap007#pass_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26. Stocks and Bonds")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/chap009#pass_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27. Internet Marketing")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/chap009#pass_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28. Communication")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/chap009#pass_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29. Speech")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/chap009#pass_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30. Semantics")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/chap009#pass_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31. Negotiation")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/chap010#pass_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32. Debt Elimination")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/chap010#pass_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33. Auctions")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/chap010#pass_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34. Networking")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/chap010#pass_35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35. Priorities")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/chap010#pass_36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36. Getting Started")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/chap010#pass_37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37. B.S. Belief Systems")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/chap011#pass_38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38. Accumulation")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/chap011#pass_39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39. Do You Remember")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/chap011#pass_40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40. Franchises")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/chap011#pass_41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41. Asset Protection")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/chap011#pass_42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42. KISS Method")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/chap011#pass_43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43. Motivation")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/chap011#pass_44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44. Reality")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/chap011#pass_45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45. Give and Take")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/chap011#pass_46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46. Passion")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/chap011#pass_47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47. Healing")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/chap011#pass_48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48. Failure")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/chap011#pass_49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49. Success")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/chap012#pass_50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50. The Destination")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e3934dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc2.vue
// module id = 72
// module chunks = 0